
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import * as StatServices from '@/services/StatServices'
@Component
export default class TotalInteractionsPerType extends Vue {
  @Prop({ required: true }) from!: Date;
  @Prop({ required: true }) to!: Date;

  explainDialog = false;

  loading = false;

  counts = {} as Record<string, number>;

  showKeys = ['CLICK', 'CLICK_TROUGH', 'FACEBOOK_SHARE', 'TWITTER_SHARE', 'WHATSAPP_SHARE', 'LINK_SHARE', 'NEWSLETTER_CLICK_TROUGH'];

  @Watch('from', { immediate: true })
  @Watch('to')
  async fetchInteractions() {
    this.loading = true;
    this.counts = {};
    const data = await StatServices.ListAggregatedInteractions(this.from, this.to)
    
    this.counts = data;
    this.$forceUpdate();

    this.loading = false;
  }
  
  getNameForKey(key: string){
    if(key === 'CLICK') return 'Klik op factcheck artikel';
    if(key === 'CLICK_TROUGH') return 'Doorverwijzing naar partner';
    if(key === 'FACEBOOK_SHARE') return 'Gedeeld via facebook';
    if(key === 'TWITTER_SHARE') return 'Gedeeld via twitter';
    if(key === 'WHATSAPP_SHARE') return 'Gedeeld via whatsapp';
    if(key === 'LINK_SHARE') return 'Artikel URL Gekopieerd';
    if(key === 'NEWSLETTER_CLICK_TROUGH') return 'Doorverwijzing naar partner via nieuwsbrief';
    
    return key;
  }
}

